import { useEffect, useState } from 'react'

/** Returns `value`, updated only after it has been stable for `delayMs`. */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
	const [debounced, setDebounced] = useState(value)
	useEffect(() => {
		const t = setTimeout(() => setDebounced(value), delayMs)
		return () => clearTimeout(t)
	}, [value, delayMs])
	return debounced
}
